/**
 * @generated SignedSource<<9f20b05e41a87ea1db542eaf9094d98e>>
 * @relayHash 111f5707b6796cd50dc24b6336217794
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/573.0.0-2026-08-18T15:46:00.544Z/PersonalizedCollectionsContextTrendingItemsQuery

import { ConcreteRequest } from 'relay-runtime';
export type PersonalizedCollectionsContextTrendingItemsQuery$variables = Record<PropertyKey, never>;
export type PersonalizedCollectionsContextTrendingItemsQuery$data = {
  readonly viewer: {
    readonly itemSearchTrendingItems: {
      readonly itemIds: ReadonlyArray<string | null> | null;
    } | null;
  };
};
export type PersonalizedCollectionsContextTrendingItemsQuery = {
  response: PersonalizedCollectionsContextTrendingItemsQuery$data;
  variables: PersonalizedCollectionsContextTrendingItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "sellerVerticals",
      "value": [
        "jewelry",
        "furniture",
        "fashion",
        "art"
      ]
    }
  ],
  "concreteType": "ItemSearchTrendingItemsResult",
  "kind": "LinkedField",
  "name": "itemSearchTrendingItems",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "itemIds",
      "storageKey": null
    }
  ],
  "storageKey": "itemSearchTrendingItems(sellerVerticals:[\"jewelry\",\"furniture\",\"fashion\",\"art\"])"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PersonalizedCollectionsContextTrendingItemsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PersonalizedCollectionsContextTrendingItemsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/573.0.0-2026-08-18T15:46:00.544Z/PersonalizedCollectionsContextTrendingItemsQuery",
    "metadata": {},
    "name": "PersonalizedCollectionsContextTrendingItemsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2fc09850ede4ace55dfff38badde7278";

export default node;
